/**
 * Documents d'autorité, dossiers de preuves, journal validation — Phase 1 mock.
 * Aucun document officiel inventé — simulation locale uniquement.
 */

/** @type {import('./types.js').AuthorityDocument[]} */
export const demoAuthorityDocuments = [
  {
    id: "doc-auth-grade-10",
    titre: "[À FOURNIR] Preuve grade 10e dan",
    type_document: "preuve_grade",
    categorie: "autorité",
    personne_liee: "[DÉMO] Responsable Shotokan Black Dragon",
    demande_titre_id: null,
    titre_id: null,
    autorite_id: "auth-demo-responsable",
    reconnaissance_id: null,
    fichier_nom: null,
    fichier_type: null,
    date_document: null,
    date_ajout: "2026-06-01",
    ajoute_par: "system",
    statut_validation: "a_fournir",
    niveau_sensibilite: "tres_confidentiel",
    notes: "Document officiel non fourni — aucune preuve jointe.",
    source: "[DOCUMENTS À FOURNIR]",
    statut_demo: "a_fournir",
    demo: true,
  },
  {
    id: "doc-auth-japan",
    titre: "[À FOURNIR] Preuve séjour / formation Japon",
    type_document: "preuve_japon",
    categorie: "autorité",
    personne_liee: "[DÉMO] Responsable Shotokan Black Dragon",
    demande_titre_id: null,
    titre_id: null,
    autorite_id: "auth-demo-responsable",
    reconnaissance_id: null,
    fichier_nom: null,
    fichier_type: null,
    date_document: null,
    date_ajout: "2026-06-01",
    ajoute_par: "system",
    statut_validation: "a_fournir",
    niveau_sensibilite: "tres_confidentiel",
    notes: "Attestation séjour — en attente du responsable.",
    source: "[DOCUMENTS À FOURNIR]",
    statut_demo: "a_fournir",
    demo: true,
  },
  {
    id: "doc-app-sensei-rec",
    titre: "[DÉMO] Lettre recommandation candidat Sensei",
    type_document: "lettre_recommandation",
    categorie: "demande_titre",
    personne_liee: "[DÉMO] Instructeur principal",
    demande_titre_id: "app-demo-sensei-01",
    titre_id: "title-sensei",
    autorite_id: null,
    reconnaissance_id: null,
    fichier_nom: "lettre_recommandation_demo.pdf",
    fichier_type: "application/pdf",
    date_document: "2026-05-10",
    date_ajout: "2026-05-12",
    ajoute_par: "demo-sensei-placeholder",
    statut_validation: "recu",
    niveau_sensibilite: "interne",
    notes: "Simulation locale — pas de fichier réel.",
    source: "[DÉMO]",
    statut_demo: "demo",
    demo: true,
  },
  {
    id: "doc-app-shihan-hist",
    titre: "[DÉMO] Historique enseignement candidat Shihan",
    type_document: "historique_enseignement",
    categorie: "demande_titre",
    personne_liee: "[DÉMO] Instructeur adjoint",
    demande_titre_id: "app-demo-shihan-01",
    titre_id: "title-shihan",
    autorite_id: null,
    reconnaissance_id: null,
    fichier_nom: "historique_enseignement_demo.pdf",
    fichier_type: "application/pdf",
    date_document: "2026-03-15",
    date_ajout: "2026-04-02",
    ajoute_par: "demo-instructeur-02",
    statut_validation: "en_revision",
    niveau_sensibilite: "interne",
    notes: "En cours de révision par l'autorité — démo.",
    source: "[DÉMO]",
    statut_demo: "demo",
    demo: true,
  },
  {
    id: "doc-app-renshi-contrib",
    titre: "[DÉMO] Contribution organisationnelle candidat Renshi",
    type_document: "contribution",
    categorie: "demande_titre",
    personne_liee: "[DÉMO] Senior instructeur",
    demande_titre_id: "app-demo-renshi-01",
    titre_id: "title-renshi",
    autorite_id: null,
    reconnaissance_id: null,
    fichier_nom: null,
    fichier_type: null,
    date_document: null,
    date_ajout: "2026-06-05",
    ajoute_par: "demo-instructeur-03",
    statut_validation: "a_fournir",
    niveau_sensibilite: "confidentiel",
    notes: "Document attendu — dossier incomplet.",
    source: "[DÉMO]",
    statut_demo: "demo",
    demo: true,
  },
];

/** @type {import('./types.js').EvidenceDossier[]} */
export const demoEvidenceDossiers = [
  {
    id: "dossier-auth-responsable",
    type_dossier: "autorite_responsable",
    sujet_id: "auth-demo-responsable",
    sujet_nom: "[DÉMO] Responsable Shotokan Black Dragon",
    titre_demande: null,
    statut_dossier: "incomplet",
    documents_requis: ["doc-auth-grade-10", "doc-auth-japan"],
    documents_recus: [],
    documents_acceptes: [],
    documents_manquants: ["doc-auth-grade-10", "doc-auth-japan"],
    score_completude: 0,
    decision_possible: false,
    notes_revision: "Preuve 10e dan et preuve Japon manquantes.",
    demo: true,
  },
  {
    id: "dossier-app-sensei",
    type_dossier: "demande_titre",
    sujet_id: "app-demo-sensei-01",
    sujet_nom: "[DÉMO] Instructeur principal — Sensei",
    titre_demande: "title-sensei",
    statut_dossier: "en_revision",
    documents_requis: ["doc-app-sensei-rec"],
    documents_recus: ["doc-app-sensei-rec"],
    documents_acceptes: [],
    documents_manquants: [],
    score_completude: 60,
    decision_possible: false,
    notes_revision: "Lettre reçue — validation en cours.",
    demo: true,
  },
  {
    id: "dossier-app-shihan",
    type_dossier: "demande_titre",
    sujet_id: "app-demo-shihan-01",
    sujet_nom: "[DÉMO] Instructeur adjoint — Shihan",
    titre_demande: "title-shihan",
    statut_dossier: "en_revision",
    documents_requis: ["doc-app-shihan-hist"],
    documents_recus: ["doc-app-shihan-hist"],
    documents_acceptes: [],
    documents_manquants: [],
    score_completude: 55,
    decision_possible: false,
    notes_revision: "Historique enseignement à valider.",
    demo: true,
  },
  {
    id: "dossier-app-renshi",
    type_dossier: "demande_titre",
    sujet_id: "app-demo-renshi-01",
    sujet_nom: "[DÉMO] Senior instructeur — Renshi",
    titre_demande: "title-renshi",
    statut_dossier: "incomplet",
    documents_requis: ["doc-app-renshi-contrib"],
    documents_recus: [],
    documents_acceptes: [],
    documents_manquants: ["doc-app-renshi-contrib"],
    score_completude: 15,
    decision_possible: false,
    notes_revision: "Contribution organisationnelle manquante.",
    demo: true,
  },
  {
    id: "dossier-reg-demo-01",
    type_dossier: "reconnaissance",
    sujet_id: "reg-demo-01",
    sujet_nom: "[DÉMO] Registre SBD-DEMO-001",
    titre_demande: "title-sensei",
    statut_dossier: "complet_a_valider",
    documents_requis: [],
    documents_recus: ["doc-app-sensei-rec"],
    documents_acceptes: [],
    documents_manquants: [],
    score_completude: 70,
    decision_possible: false,
    notes_revision: "Registre non officiel tant que dossier autorité incomplet.",
    demo: true,
  },
];

/** @type {import('./types.js').DojoDocument[]} */
export const demoDojoDocuments = [
  {
    id: "dojo-doc-politique",
    titre: "[DÉMO] Politique d'inscription",
    type_document: "autre",
    categorie: "dojo_general",
    module_lie: "Dojo général",
    personne_liee: "—",
    statut_validation: "accepte",
    niveau_sensibilite: "public",
    date_ajout: "2026-01-15",
    source: "[DÉMO]",
    demo: true,
  },
  {
    id: "dojo-doc-responsabilite",
    titre: "[DÉMO] Formulaire responsabilité",
    type_document: "identite",
    categorie: "dojo_general",
    module_lie: "Dojo général",
    personne_liee: "Étudiants / parents",
    statut_validation: "accepte",
    niveau_sensibilite: "interne",
    date_ajout: "2026-02-01",
    source: "[DÉMO]",
    demo: true,
  },
  {
    id: "dojo-doc-reglement",
    titre: "[DÉMO] Règlement dojo",
    type_document: "autre",
    categorie: "dojo_general",
    module_lie: "Dojo général",
    personne_liee: "—",
    statut_validation: "en_revision",
    niveau_sensibilite: "public",
    date_ajout: "2026-03-10",
    source: "[DÉMO]",
    demo: true,
  },
];

/** @type {import('./types.js').ValidationLogEntry[]} */
export const demoValidationLog = [
  {
    id: "log-001",
    date: "2026-06-01T10:00:00",
    acteur: "admin",
    role_acteur: "hanshi",
    action: "document_demande",
    cible_type: "authorityDocument",
    cible_id: "doc-auth-grade-10",
    ancien_statut: null,
    nouveau_statut: "a_fournir",
    commentaire: "[DÉMO] Preuve 10e dan demandée au responsable.",
    document_id: "doc-auth-grade-10",
    demande_titre_id: null,
    visibilite: "interne",
    demo: true,
  },
  {
    id: "log-002",
    date: "2026-05-12T14:30:00",
    acteur: "sensei",
    role_acteur: "sensei",
    action: "document_recu",
    cible_type: "authorityDocument",
    cible_id: "doc-app-sensei-rec",
    ancien_statut: "a_fournir",
    nouveau_statut: "recu",
    commentaire: "[DÉMO] Lettre recommandation déposée (simulation).",
    document_id: "doc-app-sensei-rec",
    demande_titre_id: "app-demo-sensei-01",
    visibilite: "interne",
    demo: true,
  },
  {
    id: "log-003",
    date: "2026-04-05T09:15:00",
    acteur: "admin",
    role_acteur: "hanshi",
    action: "dossier_revise",
    cible_type: "evidenceDossier",
    cible_id: "dossier-app-shihan",
    ancien_statut: "incomplet",
    nouveau_statut: "en_revision",
    commentaire: "[DÉMO] Dossier Shihan passé en révision.",
    document_id: "doc-app-shihan-hist",
    demande_titre_id: "app-demo-shihan-01",
    visibilite: "interne",
    demo: true,
  },
];
